import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import findResult from '@/utils/resultsHelper';
import selectors from '@/selectors';
import DatasetAttachmentsService from '@/datasets/attachments/service';
import { resolveCurrentPath } from '@/datasets/attachments/helper';
import {
  showRequestAttachments,
  showRequestAttachmentsError,
  showRequestFolderAttachments,
  showRequestFolderAttachmentsError,
} from '../actions';
import actions from '../constants';
import { requestSourceEntities } from '../../constants';

const resolveDatasetCode = (item) => {
  const source = item.steps.results?.[0];
  return item.request_source === requestSourceEntities.COHORT
    ? source?.queries?.[0]?.dataset?.code : source?.code;
};

export function* fetchRequestAttachments({
  category,
  code,
  permissions,
  allowPmnTransfer,
}) {
  const items = yield select(selectors.requests);
  const item = findResult(items, category, code);
  const datasetCode = resolveDatasetCode(item);

  const { response, error } = yield call(callAdapter, DatasetAttachmentsService.datasetAttachments(datasetCode, true));

  if (error) {
    yield put(showRequestAttachmentsError(category, code, error, permissions, allowPmnTransfer));
  } else {
    yield put(showRequestAttachments(category, code, response.items, permissions, allowPmnTransfer));
  }
}

export function* fetchRequestFolderAttachments({ category, code }) {
  const items = yield select(selectors.requests);
  const item = findResult(items, category, code);
  const { currentPathSegments } = item.steps.attachments.folders;

  if (currentPathSegments.length === 0) return;

  const datasetCode = resolveDatasetCode(item);
  const path = resolveCurrentPath(currentPathSegments);

  const { response, error } = yield call(
    callAdapter,
    DatasetAttachmentsService.datasetAttachments(datasetCode, true, true, path),
  );

  if (error) {
    yield put(showRequestFolderAttachmentsError(category, code, error));
  } else {
    yield put(showRequestFolderAttachments(category, code, response.items));
  }
}

export default function* requestAttachmentsApi() {
  yield takeEvery([
    actions.FETCH_REQUEST_ATTACHMENTS,
    actions.REQUEST_ATTACHMENT_FOLDER_PUSH,
    actions.REQUEST_ATTACHMENT_FOLDER_POP,
    actions.REQUEST_ATTACHMENT_FOLDER_NAVIGATE,
  ], fetchRequestAttachments);
}
